import React, { Component } from "react";
import { v4 as uuid } from "uuid";

/**
 * @class
 * @classdesc Progress bar control which uses the (external) radial progress bar.
 * It displays a circular progress bar which either allows displaying progress values as well
 * as a so-called "indeterminate" mode which shows an infinite loading animation when there is no measurable progress value available.
 * You can use this control as a regular JS class or inside React.
 *
 * @example
 * // Using as regular control by creating a new instance and specifiy the container where to render to progress bar.
 * // You can set the initial state with the "progress" property. See {@link HcsProgressbar#progress} for possible values.
 * 
 * let progressBar = new HcsProgressbar({
 *     hcs: ...
 *     container: document.getElementById("MyContainer")
 * });
 * 
 * // You can then change the state with:
 * 
 * progressBar.progress(<mode>).
 * 
 * // Using inside React.
 * // You can set the initial state with the "progress" property. See {@link HcsProgressbar#progress} for possible values.
 * 
 * <HcsProgressbar progress="indeterminate" />
 * 
 * @param {object} props - Properties
 * @param {any} [props.progress=false] - Set initial visibility state. See {@link HcsProgressbar#progress} modes for possible values.
 */
export default class HcsProgressbar extends Component
{
    constructor(props) {
        super(props);

        this.uid = props.id || uuid();

        this.progressMode = false;

        if(props.container) {
            let progressBarDom = document.createElement("div");
            progressBarDom.className = "hcs-radial-progressbar";
            progressBarDom.id = this.uid;
            progressBarDom.innerHTML = `<div class="hcs-progress">
                <img src="${this.props.hcs.api.getUrl(false, "css/images/Haefele_loading_02b.svg") }" />
            </div>
            <div class="hcs-background"></div>
            <div class="hcs-loader-style"></div>`;

            props.container.appendChild(progressBarDom);

            this.componentDidUpdate();
        }
    }

    componentDidUpdate() {
        if(typeof this.props.progress !== "undefined") {
            this.progress(this.props.progress);
        }
    }

    /**
     * Show progress as overlay to scene.
     * @param {any} [mode] - Control progress bar visibility and behavior:
     * "indetermiante" - show progress bar with continuous loader
     * number - show progress bar with value between 0 and 1
     * false - hide progress bar
     * @returns {any} When no "mode" argument is set the current progress state will be returned.
     * This could be either "indeterminate", the current progress value or "false" when progress bar is off.
     */
    progress(mode) {
        let element = document.getElementById(this.uid);

        switch(true) {
            case arguments.length < 1 || this.progressMode === mode:
                return this.progressMode;

            case mode === "indeterminate":
                element.classList.add("hcs-visible");
                this.progressMode = "indeterminate";
                break;

            case !isNaN(parseInt(mode)):
                element.classList.add("hcs-visible");
                this.progressMode = mode;
                break;

            case mode === false:
                element.classList.remove("hcs-visible");
                this.progressMode = false;
                break;
        }
    }

    render() {
        return (
            <div id={this.uid} className="hcs-radial-progressbar">
                <div className="hcs-progress">
                    <img src={this.props.hcs.api.getUrl(false, "css/images/Haefele_loading_02b.svg")} />
                </div>
                <div className="hcs-background" />
            </div>);
    }
}